export default __webpack_public_path__ + "static/media/darkPremiumIcon.8d3e18c0.svg";